import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { meetingsPausedMessageOf } from '../utils/meetings-pause';

export const CancelEngagementMeetingProposal = createAsyncThunk(
    'engagementMeetings/cancelMeetingProposal',
    async (
        {
            engagementId,
            meetingProposalId,
            reason,
        }: { engagementId: number; meetingProposalId: string; reason?: string },
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.delete(
                `/api/Marketplace/Engagements/${engagementId}/MeetingScheduling/${meetingProposalId}`,
                reason ? { data: { reason } } : undefined
            );

            if (response.status !== 200 && response.status !== 204) {
                createNotification(
                    meetingsPausedMessageOf(response) ?? 'Could not cancel meeting proposal at the moment.',
                    'error'
                );
                throw Object.assign(new Error('Failed to cancel meeting proposal'), { isAnnounced: true });
            }

            createNotification(
                'Meeting proposal cancelled successfully.',
                'success'
            );
            return { engagementId, meetingProposalId };
        } catch (error: any) {
            if (!error?.isAnnounced) {
                createNotification(
                    'An error occurred while cancelling the meeting proposal.',
                    'error'
                );
            }
            throw error;
        }
    }
);
